module.exports = "/_next/static/images/faq-monotone-9382f1e75c755aa116224c12b989a61c.svg";